module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0152.jpg?v=b0e4d624";